// import React, { useState } from "react";
// import "./Subscription_Plan.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faWallet } from "@fortawesome/free-solid-svg-icons";
// import Subscription_Plan_Modal from "./subscription_plan_modal/Subscription_Plan_Modal";

// const Subscription_Plan = () => {
//   const [selectedPlan, setSelectedPlan] = useState("yearly");
//   const [showModal, setShowModal] = useState(false);
//   const handleAddSubscriptionClick = () => {
//     setShowModal(true);

//     setTimeout(() => {
//       setShowModal(false);
//     }, 3000);
//   };
//   const handleCloseModal = () => {};

//   return (
//     <div className="sub-container container">
//       <div className="sub-card">
//         <h3 className="sub-title">Choose Subscription Plan</h3>

//         <div className="sub-plans">
//           <label
//             className={`plan-item yearly ${
//               selectedPlan === "yearly" ? "active" : ""
//             }`}
//           >
//             <div className="plan-details">
//               <span className="plan-name">
//                 YEARLY <span className="badge">Best value</span>
//               </span>
//               <span className="plan-price">
//                 ₹200 <small>/month</small>
//               </span>
//             </div>
//             <input
//               type="radio"
//               name="subscription"
//               value="yearly"
//               checked={selectedPlan === "yearly"}
//               onChange={() => setSelectedPlan("yearly")}
//             />
//             <div className="custom-radio-outer">
//               <div className="custom-radio-inner"></div>
//             </div>
//           </label>

//           <label
//             className={`plan-item monthly ${
//               selectedPlan === "monthly" ? "active" : ""
//             }`}
//           >
//             <div className="plan-details">
//               <span className="plan-name">MONTHLY</span>
//               <span className="plan-price">
//                 ₹300 <small>/month</small>
//               </span>
//             </div>
//             <input
//               type="radio"
//               name="subscription"
//               value="monthly"
//               checked={selectedPlan === "monthly"}
//               onChange={() => setSelectedPlan("monthly")}
//             />
//             <div className="custom-radio-outer">
//               <div className="custom-radio-inner"></div>
//             </div>
//           </label>
//         </div>

//         <div className="payment-section">
//           <h3 className="sub-title">Payment method</h3>
//           <div className="payment-method-box">
//             <div className="payment-info">
//               <span className="wallet-icon">
//                 <FontAwesomeIcon icon={faWallet} />
//               </span>
//               <span className="wallet-text">Wallet (₹1500)</span>
//             </div>
//             <div className="radio-selected-wrapper">
//               <div className="radio-selected-inner"></div>
//             </div>
//           </div>
//         </div>

//         <button className="pay-now-btn" onClick={handleAddSubscriptionClick}>
//           Pay Now
//         </button>
//       </div>

//       <Subscription_Plan_Modal
//         showAddsubscription={showModal}
//         handleAddSubscriptionClose={handleCloseModal}
//       />
//     </div>
//   );
// };

// export default Subscription_Plan;

import React, { useContext, useEffect, useState } from "react";
import "./Subscription_Plan.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWallet } from "@fortawesome/free-solid-svg-icons";
import Subscription_Plan_Modal from "./subscription_plan_modal/Subscription_Plan_Modal";
import {
  getSubscriptionPlans,
  purchaseSubscription,
  UserWalletHistory,
} from "../../../../features/admin/subscription/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../../../utils/context";
import { useRazorpay } from "react-razorpay";

const Subscription_Plan = () => {
  const dispatch = useDispatch();
  const { userdata, getUserByType, setUserData } = useContext(Context);
  const { Razorpay } = useRazorpay();
  console.log(userdata, "userdatauserdatauserdatauserdata");

  const subscriptionState = useSelector(
    (state) => state.subscription.subscriptions,
  );

  const { plans = [], status } = subscriptionState;

  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Fetch plans
  useEffect(() => {
    if (userdata?.type) {
      dispatch(
        getSubscriptionPlans({
          type: userdata.type,
          token: userdata?.token,
        }),
      );
    }
  }, [dispatch, userdata]);

  // Auto select first plan
  useEffect(() => {
    if (plans.length > 0) {
      setSelectedPlanId(plans[0].id);
    }
  }, [plans]);

  const selectedPlan = plans.find((p) => p.id === selectedPlanId);

  // PAY NOW
  const handleAddSubscriptionClick = () => {
    setErrorMessage("");

    if (!selectedPlan) return;

    // FREE PLAN
    if (parseFloat(selectedPlan.amount) === 0) {
      directPurchase("FREE");
      return;
    }

    openRazorpay(selectedPlan);
  };

  // Razorpay
  const openRazorpay = (plan) => {
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY || "rzp_test_I05KCFb1v5JJRc",
      amount: Math.round(parseFloat(plan.amount) * 100),
      currency: "INR",
      name: "Subscription Payment",
      description: plan.name,
      handler: (response) => {
        directPurchase(response.razorpay_payment_id);
      },
      prefill: {
        name: userdata?.name || "",
        email: userdata?.email || "",
        contact: userdata?.mobile || "",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzp = new Razorpay(options);
    rzp.open();
  };

  // API CALL (🔥 SAME PATTERN AS LOGIN)
  const directPurchase = async (transactionNumber) => {
    const formData = new FormData();
    formData.append("subscription_id", selectedPlan.id);
    formData.append("amount", selectedPlan.amount);
    formData.append("transaction_number", transactionNumber);

    const res = await dispatch(purchaseSubscription(formData));

    // SUCCESS
    // if (res?.meta?.requestStatus === "fulfilled") {
    //   setShowModal(true);
    //   await dispatch(UserWalletHistory());
    //   setTimeout(() => setShowModal(false), 3000);
    // }
    if (res?.meta?.requestStatus === "fulfilled") {
      setShowModal(true);

      await dispatch(UserWalletHistory());

      // ✅ INSTANT UI UPDATE (NO REFRESH)
      setUserData((prev) => ({
        ...prev,
        subscription_status: true,
      }));

      // OPTIONAL (sync with backend)
      await getUserByType(userdata?.type);

      setTimeout(() => setShowModal(false), 3000);
    }

    //  BACKEND FAILURE (REAL MESSAGE)
    if (res?.meta?.requestStatus === "rejected") {
      const backendMessage =
        res?.payload?.message ||
        res?.payload?.response?.data?.message ||
        "Subscription failed";

      setErrorMessage(backendMessage);
    }
  };

  const userSubscriptions = userdata?.user_subscription || [];

  const activeSubscription = userSubscriptions.find((sub) => {
    if (!sub?.end_date) return false;

    const endDate = new Date(sub.end_date);
    const today = new Date();

    return endDate > today;
  });

  const isFreePlanActive = activeSubscription?.amount === 0;

  const canPurchase =
    !activeSubscription || // no subscription
    isFreePlanActive || // free subscription active
    new Date(activeSubscription?.end_date) < new Date(); // expired

  return (
    <div className="sub-container container">
      <div className="sub-card">
        <h3 className="sub-title">Choose Subscription Plan</h3>

        <div className="sub-plans">
          {plans.map((plan) => (
            <label
              key={plan.id}
              className={`plan-item ${plan.period} ${selectedPlanId === plan.id ? "active" : ""
                }`}
            >
              <div className="plan-details">
                <span className="plan-name">
                  {plan.name}
                  {plan.period === "yearly" && (
                    <span className="badge">Best value</span>
                  )}
                </span>

                <span className="plan-price">
                  ₹{plan.amount} <small>/{plan.period}</small>
                </span>
              </div>

              <input
                type="radio"
                name="subscription"
                value={plan.id}
                checked={selectedPlanId === plan.id}
                onChange={() => setSelectedPlanId(plan.id)}
              />

              <div className="custom-radio-outer">
                <div className="custom-radio-inner"></div>
              </div>
            </label>
          ))}
        </div>

        {canPurchase && (
          <button
            className="pay-now-btn"
            disabled={!selectedPlanId || status === "loading"}
            onClick={handleAddSubscriptionClick}
          >
            Pay Now
          </button>
        )}

        {/* ✅ BACKEND ERROR (NO CSS CHANGE) */}
        {errorMessage && (
          <p style={{ color: "red", marginTop: "10px", textAlign: "center" }}>
            {errorMessage}
          </p>
        )}
      </div>

      <Subscription_Plan_Modal
        showAddsubscription={showModal}
        handleAddSubscriptionClose={() => setShowModal(false)}
        selectedPlanId={selectedPlanId}
      />
    </div>
  );
};

export default Subscription_Plan;
